import { isPageLoadMetricData, isPageSegmentLoadMetricData } from '../../metric/types';
export const eventInitial = (_config, data) => {
  if (!isPageLoadMetricData(data) && !isPageSegmentLoadMetricData(data)) {
    return null;
  }

  return {
    'event:initial': data.isInitial
  };
};